import {useEffect} from 'react';

import {useContentDiscoveryStore} from '../ContentDiscoveryStore.react';

export const useDraftSubscription = () => {
  useEffect(() => {
    const unsubscribers = [
      useContentDiscoveryStore.subscribe(
        (state) => state.assignment.assignment,
        (initialAssignment) => {
          // Read the slice per fire, not once at mount: the immer middleware copy-on-writes a
          // fresh `draft` object on every write, so a captured slice reports a stale
          // `draftName` and writing it back clobbers a rename made since mount (#20122).
          const {draft} = useContentDiscoveryStore.getState();
          if (initialAssignment && !draft.draftName) {
            draft.setDraftName(initialAssignment.getName());
          }
        }
      )
    ];

    return () => {
      unsubscribers.forEach((unsub) => unsub());
    };
  }, []);
};
